export default __webpack_public_path__ + "assets/25acab0a978d8c21fab8a3b86dfdb04c.png";